<template>
    <div class="price">
        <span class="js-price-is-much" v-if="hasVariations">{{ priceIsMuchText }}</span>
        {{ mainPriceWithoutTax }} {{ currency }}
    </div>
</template>

<script>
    export default {
        props: {
            hasVariationsProp: {
                required: true,
                type: String
            },
            priceWithoutTax: {
                required: true,
                type: String
            },
            priceIsMuchText: {
                required: true,
                type: String
            },
            currency: {
                required: true,
                type: String
            }
        },

        data() {
            return {
                mainPriceWithoutTax: this.priceWithoutTax,
                hasVariations: this.hasVariationsProp
            }
        },

        mounted() {
            this.$root.$on('setProduct', (data) => {
                this.mainPriceWithoutTax = this.getPriceWithoutTax(data.productPrice);
                this.hasVariations       = data.hasVariations;
            });
        },

        methods: {
            getPriceWithoutTax(price) {
                return (price / 1.23).toFixed(2);
            }
        }
    }
</script>
